module.exports = __webpack_public_path__ + "static/img/ic-5.22254bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ic-5.svg
// module id = XE1g
// module chunks = 1